module.exports = __webpack_public_path__ + "a9c5fde4490628b343d9310d7a7ba941.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/banana-peel-s.png
// module id = 2483
// module chunks = 0